/* tslint:disable */
import { Injectable, Inject, Optional } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { SDKModels } from './SDKModels';
import { BaseLoopBackApi } from '../core/base.service';
import { LoopBackConfig } from '../../lb.config';
import { LoopBackAuth } from '../core/auth.service';
import { LoopBackFilter,  } from '../../models/BaseModels';
import { ErrorHandler } from '../core/error.service';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { Export } from '../../models/Export';
import { SocketConnection } from '../../sockets/socket.connections';


/**
 * Api services for the `Export` model.
 */
@Injectable()
export class ExportApi extends BaseLoopBackApi {

  constructor(
    @Inject(HttpClient) protected http: HttpClient,
    @Inject(SocketConnection) protected connection: SocketConnection,
    @Inject(SDKModels) protected models: SDKModels,
    @Inject(LoopBackAuth) protected auth: LoopBackAuth,
    @Optional() @Inject(ErrorHandler) protected errorHandler: ErrorHandler
  ) {
    super(http,  connection,  models, auth, errorHandler);
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {string} exportName ClassroomAndTeachers & NumberOfClassroomsCreatedPerDay are not avaliable
   *
   * @param {string} format csv, json
   *
   * @param {date} startingAt Starting At
   *
   * @param {date} endingAt Ending At
   *
   * @param {number} timeZone Future Use - Time Zone Offset
   *
   * @param {object} options future use
   *
   * @param {object} res 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * Data properties:
   *
   *  - `` – `{}` - 
   */
  public export(exportName: String, format: String, startingAt: Date = new Date(), endingAt: Date = new Date(), timeZone: Number = new Number(), options: any = {}, res: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/Exports/export";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof exportName !== 'undefined' && exportName !== null) _urlParams.exportName = exportName;
    if (typeof format !== 'undefined' && format !== null) _urlParams.format = format;
    if (typeof startingAt !== 'undefined' && startingAt !== null) _urlParams.startingAt = startingAt;
    if (typeof endingAt !== 'undefined' && endingAt !== null) _urlParams.endingAt = endingAt;
    if (typeof timeZone !== 'undefined' && timeZone !== null) _urlParams.timeZone = timeZone;
    if (typeof options !== 'undefined' && options !== null) _urlParams.options = options;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @returns {object[]} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `Export` object.)
   * </em>
   */
  public exportTypes(customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/Exports/exportTypes";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * The name of the model represented by this $resource,
   * i.e. `Export`.
   */
  public getModelName() {
    return "Export";
  }
}
